/////////////-----------------Login Action------------------///////////
export const GET_PROFILE = "GET_PROFILE";
export const PROFILE_SUCCESS = "PROFILE_SUCCESS";
export const PROFILE_FAIL = "PROFILE_FAIL";



